// Helper: convert hours to working days. 1 day = 8 hours by default.
export const HOURS_PER_DAY = 8;

const fmt = (n) => {
  if (n == null || isNaN(n)) return "0";
  // 1 decimal for fractional days (e.g. 5.5d), integer for whole days
  return Math.abs(n - Math.round(n)) < 0.05 ? String(Math.round(n)) : n.toFixed(1).replace(".", ",");
};

export const hoursToDays = (h) => (h || 0) / HOURS_PER_DAY;

/** "120h ≈ 15 T." */
export const formatHoursWithDays = (hours, opts = {}) => {
  const hourLabel = opts.hourLabel || "h";
  const dayLabel = opts.dayLabel || "T.";
  const sep = opts.sep || " · ";
  const days = hoursToDays(hours);
  return `${fmt(hours)}${hourLabel}${sep}≈ ${fmt(days)} ${dayLabel}`;
};

/** "200–400 h · 25–50 T." */
export const formatHoursRangeWithDays = (min, max, opts = {}) => {
  const hourLabel = opts.hourLabel || "h";
  const dayLabel = opts.dayLabel || "T.";
  const sep = opts.sep || " · ";
  const dMin = hoursToDays(min);
  const dMax = hoursToDays(max);
  return `${fmt(min)}–${fmt(max)} ${hourLabel}${sep}≈ ${fmt(dMin)}–${fmt(dMax)} ${dayLabel}`;
};

/** Just the days portion: "≈ 25–50 Tage" */
export const formatDaysOnly = (min, max, dayLabel = "Tage") => {
  const dMin = hoursToDays(min);
  const dMax = (max == null) ? null : hoursToDays(max);
  if (dMax == null || dMin === dMax) return `≈ ${fmt(dMin)} ${dayLabel}`;
  return `≈ ${fmt(dMin)}–${fmt(dMax)} ${dayLabel}`;
};
